import { default as Queue } from './Queue';

export { Queue };



// WEBPACK FOOTER //
// src/modules/screens/settings/Queue/components/index.js